module.exports = __webpack_public_path__ + "static/about-one-62cb3b5318b4f41fcdee4026e1cdbffb.jpg";